// extracted by mini-css-extract-plugin
export default {"header":"qcECfC1C","headerTitle":"aPMW4shy","menuButton":"ZaxPb1W8"};